"use client";

import { useScrollDepthTracking } from "@/hooks/useScrollDepthTracking";

export default function HomePageTracker() {
  useScrollDepthTracking();
  return null;
}
